import customHandlers from '../helpers/custom-handlers';

const unsubscribe = (hookName, callback) => {
  if (customHandlers.has(hookName)) {
    const handlers = customHandlers.get(hookName);
    customHandlers.set(
      hookName,
      handlers.filter((handler) => handler !== callback)
    );
  }
};

export default unsubscribe;
